import React from 'react';
import moment from 'moment';
import { isValidDate } from '@/utils/helpers';

const BirthdayCell = ({
    birthday,
    age,
    emptyText = '—',
    showAge = true,
    dateFormatStrict = false, // truyền vào isValidDate(birthday, dateFormatStrict)
}) => {
    if (!birthday) return <span style={{ color: '#bfbfbf' }}>{emptyText}</span>;

    const birthDate = moment(birthday);
    if (!birthDate.isValid()) return <span style={{ color: '#bfbfbf' }}>{emptyText}</span>;

    const formattedDate = isValidDate(birthday, dateFormatStrict);

    return (
        <div style={{ lineHeight: 1.3 }}>
            <div style={{ fontWeight: 500, color: '#222' }}>{formattedDate}</div>

            {showAge && age ? (
                <div style={{ fontSize: 14, color: '#8c8c8c', marginTop: 2 }}>
                    {age} tuổi
                </div>
            ) : null}
        </div>
    );
};

export default BirthdayCell;